import apiClient from './config';
import POLL_ENDPOINTS from './endpoints/pollEndpoints';

const pollService = {
  // "Take this poll" page load — no side effects, just returns the poll (or
  // an expired/already-voted status) for the vote form to render. The
  // `format=json` flag tells the backend this is an AJAX fetch (always
  // respond with JSON), as opposed to a real one-tap vote link, which is a
  // browser navigation the backend redirects instead.
  getPollByToken: (token) => {
    return apiClient.get(`${POLL_ENDPOINTS.POLL_VOTE}/${token}`, {
      params: { format: 'json' },
    });
  },

  // Multi-select vote submission from the web form.
  submitPollVote: (token, optionIds) => {
    return apiClient.post(`${POLL_ENDPOINTS.POLL_VOTE}/${token}`, {
      option_ids: optionIds,
    });
  },
};

export default pollService;
